import { Theme } from '@platform-ui-kit/components-library'

import { facadeApi } from 'api'

export const fetchCurrentTenantThemeApi = () => facadeApi.get<{ data: Theme }>('/tenants/current/theme')
